import React from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const SportsPassFormFilterDays = ({sportsPassFilterFilterActiveDays, OnChangeFilterDays}) => 
	<Select 
		className="generic-filters-select generic-filters-select-day sports-pass-filters-select sports-pass-filters-select-day" 
		name="sports-pass-filters-day" 
		placeholder="Tous les jours" 
		options={SELECTS['days']} 
		onChange={OnChangeFilterDays}
		value={sportsPassFilterFilterActiveDays}
		simpleValue
		clearable={false}
		searchable={false}
		aria-label="Sélectionner les jours d'activité"
	/>

export default SportsPassFormFilterDays
